__turbopack_context__.v({
  "aiBadge": "VfofOW_aiBadge",
  "aiBadgeIcon": "VfofOW_aiBadgeIcon",
  "askAi": "VfofOW_askAi",
  "clear": "VfofOW_clear",
  "clearLabel": "VfofOW_clearLabel",
  "content": "VfofOW_content",
  "dropdown": "VfofOW_dropdown",
  "hint": "VfofOW_hint",
  "idle": "VfofOW_idle",
  "input": "VfofOW_input",
  "inputRoot": "VfofOW_inputRoot",
  "noResults": "VfofOW_noResults",
  "noResultsContent": "VfofOW_noResultsContent",
  "root": "VfofOW_root",
  "rootOpen": "VfofOW_rootOpen",
  "searchGlyph": "VfofOW_searchGlyph",
});
